<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        small
        class="language-selector"
        :aria-label="$t('Language')"
        v-bind="attrs"
        v-on="on"
      >
        {{ $i18n.locale === 'es-ES' ? 'ES' : 'EN' }}
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item
        :disabled="saving"
        @click="choose('en')"
      >
        <v-list-item-title lang="en">
          English
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        :disabled="saving"
        @click="choose('es-ES')"
      >
        <v-list-item-title lang="es">
          Español
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import { setLocale } from '@/i18n'

export default {
  data: () => ({ saving: false }),
  methods: { async choose(locale) { this.saving = true; try { await setLocale(locale) } finally { this.saving = false } } },
}
</script>
<style scoped>
.language-selector { min-width: 40px !important; padding: 0 6px !important; letter-spacing: .04em; }
</style>
